import { useEffect, useRef } from "react";
import "./WashtaHero.css";

import washtaLogoMark from "./assets/washta-logo-mark.png";
import washtaBrandIcon from "./assets/washta-brand-icon.png";
import exteriorWashImg from "./assets/exterior-wash.jpg";
import detailingImg from "./assets/full-detailing.png";
import ceramicCoatingImg from "./assets/ceramic-coating.jpg";

export default function WashtaHero() {
  const phoneRef = useRef(null);

  useEffect(() => {
    const phone = phoneRef.current;
    if (!phone) return;

    const panels = Array.from(phone.querySelectorAll(".wsh-fs"));
    const dots = Array.from(phone.querySelectorAll(".wsh-pf-stepper i"));
    const homeCta = phone.querySelector("#wsh-homeCta");
    const svcCta = phone.querySelector("#wsh-svcCta");
    const addon = phone.querySelector("#wsh-addonFresh");
    const notif = phone.querySelector("#wsh-pfNotif");
    const locScroll = phone.querySelector("#wsh-locScroll");
    const locSel = phone.querySelector(".wsh-loc-item.wsh-sel");
    const svcExt = phone.querySelector("#wsh-svcExterior");
    const payCta = phone.querySelector("#wsh-payCta");
    const launch = phone.querySelector("#wsh-appLaunch");
    const waIcon = phone.querySelector("#wsh-washtaIcon");
    const screenEl = phone.querySelector(".wsh-screen");

    if (panels.length < 7) return;

    let stopped = false;
    const timers = new Set();

    const wait = (ms) =>
      new Promise((resolve) => {
        const id = window.setTimeout(() => {
          timers.delete(id);
          resolve();
        }, ms);
        timers.add(id);
      });

    const safeClass = (el, action, ...classes) => {
      if (el) el.classList[action](...classes);
    };

    const show = (index) => {
      panels.forEach((panel, n) => {
        panel.classList.remove("wsh-active", "wsh-past", "wsh-future");
        panel.classList.add(n === index ? "wsh-active" : n < index ? "wsh-past" : "wsh-future");
      });
      dots.forEach((dot, n) => dot.classList.toggle("wsh-on", n === index));
    };

    const tap = (el) => {
      if (!el) return;
      el.classList.add("wsh-tapped");
      const id = window.setTimeout(() => {
        el.classList.remove("wsh-tapped");
        timers.delete(id);
      }, 560);
      timers.add(id);
    };

    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      show(0);
      return () => timers.forEach((id) => window.clearTimeout(id));
    }

    async function loop() {
      while (!stopped) {
        addon?.querySelector(".wsh-pf-check")?.classList.remove("wsh-on");
        if (svcCta) svcCta.textContent = "Continue · AED 20";
        safeClass(notif, "remove", "wsh-in");
        safeClass(svcExt, "remove", "wsh-sel", "wsh-pulse");
        if (locScroll) locScroll.scrollTop = 0;
        safeClass(locSel, "remove", "wsh-pulse");
        safeClass(waIcon, "remove", "wsh-pressed");
        if (launch) {
          launch.classList.remove("wsh-opening", "wsh-done");
          launch.style.transform = "";
          launch.style.opacity = "";
        }

        show(0);
        await wait(1500);
        if (stopped) break;

        if (waIcon) {
          waIcon.classList.add("wsh-pressed");
          await wait(220);
          waIcon.classList.remove("wsh-pressed");
          await wait(110);
        }

        if (launch && waIcon && screenEl) {
          const iconRect = waIcon.getBoundingClientRect();
          const screenRect = screenEl.getBoundingClientRect();
          launch.style.setProperty("--ox", `${(((iconRect.left + iconRect.width / 2 - screenRect.left) / screenRect.width) * 100).toFixed(1)}%`);
          launch.style.setProperty("--oy", `${(((iconRect.top + iconRect.height / 2 - screenRect.top) / screenRect.height) * 100).toFixed(1)}%`);
          launch.classList.add("wsh-opening");
          await wait(950);
        }

        show(1);
        await wait(100);
        safeClass(launch, "add", "wsh-done");
        await wait(650);

        if (locScroll) {
          locScroll.scrollTo({ top: locScroll.scrollHeight, behavior: "smooth" });
          await wait(1200);
          locScroll.scrollTo({ top: 0, behavior: "smooth" });
          await wait(900);
        }

        if (locSel) {
          void locSel.offsetWidth;
          locSel.classList.add("wsh-pulse");
        }
        await wait(900);

        show(2);
        await wait(1500);
        if (svcExt) {
          svcExt.classList.add("wsh-sel");
          void svcExt.offsetWidth;
          svcExt.classList.add("wsh-pulse");
        }
        await wait(1100);
        tap(homeCta);
        await wait(680);

        show(3);
        await wait(1800);
        addon?.querySelector(".wsh-pf-check")?.classList.add("wsh-on");
        if (svcCta) svcCta.textContent = "Continue · AED 25";
        await wait(1500);
        tap(svcCta);
        await wait(680);

        show(4);
        await wait(2600);
        tap(payCta);
        await wait(760);

        show(5);
        await wait(3000);

        show(6);
        await wait(650);
        safeClass(notif, "add", "wsh-in");
        await wait(3600);
      }
    }

    loop();

    return () => {
      stopped = true;
      timers.forEach((id) => window.clearTimeout(id));
      timers.clear();
    };
  }, []);

  return (
    <section className="wsh-hero">
<div className="wsh-wrap wsh-hero-grid">
<div className="wsh-hero-copy">
<div className="wsh-hero-eyebrow wsh-reveal"><span className="wsh-dot"></span> Stationed car care · Dubai &amp; Abu Dhabi</div>
<h1 className="wsh-hero-title wsh-reveal wsh-d1">Park. Shop.<br/>Drive away <span className="wsh-accent">clean.</span></h1>
<p className="wsh-hero-sub wsh-reveal wsh-d2">Book a carwash while you're parked at the mall. A stationed crew is already there — your car's clean by the time you're done shopping.</p>
<div className="wsh-hero-actions wsh-reveal wsh-d3" style={{paddingTop:20}}>
<a className="wsh-btn wsh-btn-primary" href="#" style={{color:'white'}}>Get the app</a>
<a className="wsh-btn wsh-btn-outline" href="/for-providers">Become a provider</a>
</div>
<div className="wsh-hero-trust wsh-reveal wsh-d4">
<div className="wsh-av"><span>A</span><span>R</span><span>M</span><span>+</span></div>
        Trusted by drivers across 50+ mall locations
      </div>
</div>
<div className="wsh-phone-stage">
<div className="wsh-glow"></div>

<div className="wsh-float-chip wsh-c1 wsh-reveal wsh-d3">
<div className="wsh-chip"><span className="wsh-chip-num">45 min</span> average wash</div>
</div>
<div className="wsh-float-chip wsh-c2 wsh-reveal wsh-d5">
<div className="wsh-chip"><span className="wsh-dot"></span> Stationed at <b> 50+ mall locations</b></div>
</div>
<div ref={phoneRef} className="wsh-phone wsh-reveal wsh-d2">
<div className="wsh-phone-notch"></div>
<div className="wsh-screen">

<div className="wsh-fs wsh-fs-spring wsh-active" data-screen-label="Step 1 — Home screen">
<div className="wsh-pf-statusbar" style={{ color: "#fff" }}><span>9:41</span><span>5G  100%</span></div>
<div className="wsh-spring">
<div className="wsh-spring-grid">
<div className="wsh-app wsh-ic-facetime"><div className="wsh-gly"><svg fill="currentColor" viewBox="0 0 24 24"><rect height="12" rx="3" width="12" x="3" y="6"></rect><path d="M16 10l5-3v10l-5-3z"></path></svg></div><span className="wsh-app-label">FaceTime</span></div>
<div className="wsh-app wsh-ic-cal"><div className="wsh-gly" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "0", lineHeight: "1" }}><span style={{ fontFamily: "'DM Sans',sans-serif", color: "#FF3B30", fontSize: "6.5px", fontWeight: "700", letterSpacing: ".12em" }}>THU</span><span className="wsh-lt" style={{ color: "#1A1A1A", fontSize: "23px" }}>18</span></div><span className="wsh-app-label">Calendar</span></div>
<div className="wsh-app wsh-ic-photos"><div className="wsh-gly"><span style={{ display: "block", width: "58%", height: "58%", borderRadius: "50%", background: "conic-gradient(from 0deg,#F9CE46,#F45D9C,#A35CF0,#3E8DF6,#46C66D,#F9CE46)" }}></span></div><span className="wsh-app-label">Photos</span></div>
<div className="wsh-app wsh-ic-cam"><div className="wsh-gly"><svg viewBox="0 0 24 24"><circle cx="12" cy="13" fill="none" r="4.2" stroke="#fff" strokeWidth="1.8"></circle><rect fill="#fff" height="2.6" rx="1" width="5" x="7" y="6.4"></rect><circle cx="17" cy="9" fill="#fff" r="1"></circle></svg></div><span className="wsh-app-label">Camera</span></div>
<div className="wsh-app wsh-ic-mail"><div className="wsh-gly"><svg viewBox="0 0 24 24"><rect fill="#fff" height="12" rx="2.5" width="18" x="3" y="6"></rect><path d="M4 8l8 5 8-5" fill="none" stroke="#1565E0" strokeWidth="1.6"></path></svg></div><span className="wsh-app-label">Mail</span></div>
<div className="wsh-app wsh-ic-notes"><div className="wsh-gly"><svg fill="none" stroke="#B07D00" strokeLinecap="round" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M7 8h10M7 12h10M7 16h6"></path></svg></div><span className="wsh-app-label">Notes</span></div>
<div className="wsh-app wsh-ic-rem"><div className="wsh-gly"><svg fill="none" viewBox="0 0 24 24"><circle cx="7" cy="8" r="1.8" stroke="#FF3B30" strokeWidth="2"></circle><circle cx="7" cy="14" r="1.8" stroke="#FF9500" strokeWidth="2"></circle><path d="M11 8h6M11 14h6" stroke="#C9CDD3" strokeLinecap="round" strokeWidth="2"></path></svg></div><span className="wsh-app-label">Reminders</span></div>
<div className="wsh-app wsh-ic-clock"><div className="wsh-gly"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" fill="#fff" r="9"></circle><path d="M12 6.5V12l3.6 2.1" fill="none" stroke="#0B0B0D" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg></div><span className="wsh-app-label">Clock</span></div>
<div className="wsh-app wsh-ic-news"><div className="wsh-gly"><span className="wsh-lt" style={{ color: "#fff", fontSize: "50%" }}>N</span></div><span className="wsh-app-label">News</span></div>
<div className="wsh-app wsh-ic-tv"><div className="wsh-gly"><span className="wsh-lt" style={{ color: "#fff", fontSize: "34%", letterSpacing: "-.03em" }}>tv</span></div><span className="wsh-app-label">TV</span></div>
<div className="wsh-app wsh-ic-appstore"><div className="wsh-gly"><svg fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M7 17l3.3-6M17 17l-4.3-7.6-1.1 1.9M9.4 15h5.2"></path></svg></div><span className="wsh-app-label">App Store</span></div>
<div className="wsh-app wsh-ic-maps"><div className="wsh-gly"><svg viewBox="0 0 24 24"><path d="M12 2.5c-3.2 0-5.8 2.6-5.8 5.8 0 4.3 5.8 11.2 5.8 11.2s5.8-6.9 5.8-11.2c0-3.2-2.6-5.8-5.8-5.8z" fill="#fff"></path><circle cx="12" cy="8.3" fill="#46B6C6" r="2.1"></circle></svg></div><span className="wsh-app-label">Maps</span></div>
<div className="wsh-app wsh-ic-health"><div className="wsh-gly"><svg fill="#FF2D55" viewBox="0 0 24 24"><path d="M12 20s-7-4.7-7-9.7A4.3 4.3 0 0112 7a4.3 4.3 0 017 3.3C19 15.3 12 20 12 20z"></path></svg></div><span className="wsh-app-label">Health</span></div>
<div className="wsh-app wsh-ic-wallet"><div className="wsh-gly"><svg viewBox="0 0 24 24"><rect fill="#FF6B6B" height="3.3" rx="1.4" width="16" x="4" y="7"></rect><rect fill="#5BD75F" height="3.3" rx="1.4" width="16" x="4" y="10.9"></rect><rect fill="#4DA2FF" height="3.3" rx="1.4" width="16" x="4" y="14.8"></rect></svg></div><span className="wsh-app-label">Wallet</span></div>
<div className="wsh-app wsh-ic-set"><div className="wsh-gly"><svg fill="none" stroke="#fff" strokeWidth="1.5" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M12 4v2M12 18v2M4 12h2M18 12h2M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M17.7 6.3l-1.4 1.4M7.7 16.3l-1.4 1.4" strokeLinecap="round"></path></svg></div><span className="wsh-app-label">Settings</span></div>
<div className="wsh-app wsh-wa" id="wsh-washtaIcon">
<img alt="Washta" src={washtaLogoMark}/>
<span className="wsh-wa-label">Washta</span>
</div>
</div>
<div className="wsh-spring-search">
<svg fill="none" stroke="currentColor" strokeWidth="2.4" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4-4"></path></svg>
                Search
              </div>
<div className="wsh-spring-dock">
<div className="wsh-app wsh-ic-phone"><div className="wsh-gly"><svg fill="currentColor" viewBox="0 0 24 24"><path d="M6.6 3.5c.9 0 1.5.4 1.9 1.3l1 2.2c.3.8.1 1.3-.5 1.9l-1 .9c.8 1.8 2.3 3.3 4.1 4.1l.9-1c.6-.6 1.1-.7 1.9-.5l2.2 1c.9.4 1.3 1 1.3 1.9 0 2.9-2.3 4.3-4.5 3.8C9.6 21.4 2.6 14.4 2.8 8c0-2.2.9-4.5 3.8-4.5z"></path></svg></div></div>
<div className="wsh-app wsh-ic-safari"><div className="wsh-gly"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" fill="none" r="9" stroke="currentColor" strokeWidth="1.4"></circle><path d="M13 7.5l3.2 3.5L11 13z" fill="#F0463A"></path><path d="M11 16.5L7.8 13 13 11z" fill="#C9D1DC"></path></svg></div></div>
<div className="wsh-app wsh-ic-msg"><div className="wsh-gly"><svg fill="currentColor" viewBox="0 0 24 24"><path d="M12 4C6.9 4 3 7.2 3 11.3c0 2.2 1.2 4.2 3.1 5.5-.2 1-.8 2.2-1.7 3.1 0 .2.2.3.4.3 1.8-.2 3.2-.9 4.1-1.5 1 .3 2 .4 3.1.4 5.1 0 9-3.2 9-7.6S17.1 4 12 4z"></path></svg></div></div>
<div className="wsh-app wsh-ic-music"><div className="wsh-gly"><svg viewBox="0 0 24 24"><path d="M9 17V6l9-2v9" fill="none" stroke="#fff" strokeWidth="1.8"></path><circle cx="7" cy="17" fill="#fff" r="2.1"></circle><circle cx="16" cy="15" fill="#fff" r="2.1"></circle></svg></div></div>
</div>
</div>
</div>

<div className="wsh-fs wsh-fs-locate wsh-future" data-screen-label="Step 2 — Locations">
<div className="wsh-pf-statusbar"><span>9:41</span><span>5G  100%</span></div>
<div className="wsh-loc-pop">
<div className="wsh-loc-confirm">
<span className="wsh-loc-pin">📍</span>
<span className="wsh-loc-confirm-txt"><b id="wsh-locConfirmName">Dubai Mall</b> — confirmed</span>
<span className="wsh-loc-change">Change ▾</span>
</div>
<div className="wsh-loc-card">
<div className="wsh-loc-search">
<svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4-4"></path></svg>
                  Search mall or building…
                </div>
<div className="wsh-loc-scroll" id="wsh-locScroll">
<div className="wsh-loc-sec">Malls</div>
<div className="wsh-loc-item wsh-sel">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="14" x="5" y="3"></rect><path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Dubai Mall</div><div className="wsh-loc-sub">Downtown · GeoWash</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-item">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="14" x="5" y="3"></rect><path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Dubai Festival City</div><div className="wsh-loc-sub">Festival City · GeoWash</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-item">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="14" x="5" y="3"></rect><path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Mirdif City Centre</div><div className="wsh-loc-sub">Mirdif · GeoWash</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-item">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="14" x="5" y="3"></rect><path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Yas Mall</div><div className="wsh-loc-sub">Yas Island · GeoWash</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-item">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="14" x="5" y="3"></rect><path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Al Wahda Mall</div><div className="wsh-loc-sub">Istiqlal St · GeoWash</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-item">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="14" x="5" y="3"></rect><path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Reem Mall</div><div className="wsh-loc-sub">Reem Island · GeoWash</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-sec">Residential</div>
<div className="wsh-loc-item wsh-res">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="12" x="6" y="3"></rect><path d="M10 8h.01M14 8h.01M10 12h.01M14 12h.01M10 16h4"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Al Reem – Bldg A</div><div className="wsh-loc-sub">Reem Island · Provider X</div></div>
<div className="wsh-loc-check">✓</div>
</div>
<div className="wsh-loc-item wsh-res">
<div className="wsh-loc-bld"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="18" rx="1" width="12" x="6" y="3"></rect><path d="M10 8h.01M14 8h.01M10 12h.01M14 12h.01M10 16h4"></path></svg></div>
<div className="wsh-loc-meta"><div className="wsh-loc-name">Shams 1 – JBR</div><div className="wsh-loc-sub">JBR · Provider Y</div></div>
<div className="wsh-loc-check">✓</div>
</div>
</div>
</div>
</div>
</div>

<div className="wsh-fs wsh-fs-home" data-screen-label="Step 3 — Home">
<div className="wsh-screen-top">
<div className="wsh-screen-status"><span>9:41</span><span>5G  100%</span></div>
<div className="wsh-screen-hello"><img alt="" className="wsh-brand-ic" src={washtaBrandIcon}/> Good afternoon 👋</div>
<div className="wsh-screen-loc">
<svg fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path d="M12 21s-7-6.3-7-11a7 7 0 0114 0c0 4.7-7 11-7 11z"></path><circle cx="12" cy="10" r="2.4"></circle></svg>
              Dubai Mall · Bay P2-114
            </div>
<div className="wsh-come-badge"><span className="wsh-dot"></span> We come to you</div>
</div>
<div className="wsh-screen-body">
<div className="wsh-screen-h">Pick a service</div>
<div className="wsh-svc" id="wsh-svcExterior">
<div className="wsh-svc-ic wsh-photo"><img alt="Exterior wash" src={exteriorWashImg}/></div>
<div className="wsh-svc-meta"><div className="wsh-t">Exterior wash</div><div className="wsh-d">Stationed crew · 15 min</div></div>
<div className="wsh-svc-price">AED 20<small>From</small></div>
</div>
<div className="wsh-svc">
<div className="wsh-svc-ic wsh-photo"><img alt="Full detailing" src={detailingImg}/></div>
<div className="wsh-svc-meta"><div className="wsh-t">Full detailing</div><div className="wsh-d">Interior + exterior · 60 min</div></div>
<div className="wsh-svc-price">AED 90<small>From</small></div>
</div>
<div className="wsh-svc">
<div className="wsh-svc-ic wsh-photo"><img alt="Ceramic coating" src={ceramicCoatingImg}/></div>
<div className="wsh-svc-meta"><div className="wsh-t">Ceramic coating</div><div className="wsh-d">Long-lasting shine</div></div>
<div className="wsh-svc-price">AED 350<small>From</small></div>
</div>
<div className="wsh-screen-cta wsh-fs-cta" id="wsh-homeCta">Book now</div>
</div>
</div>

<div className="wsh-fs wsh-fs-service wsh-future" data-screen-label="Step 4 — Service">
<div className="wsh-pf-statusbar"><span>9:41</span><span>5G  100%</span></div>
<div className="wsh-pf-top">
<div className="wsh-pf-back">← Back</div>
<div className="wsh-pf-title">Exterior wash</div>
</div>
<div className="wsh-pf-provider">
<div className="wsh-pf-plogo">GW</div>
<div className="wsh-pf-pinfo">
<div className="wsh-pf-pname">GeoWash</div>
<div className="wsh-pf-psub">Dubai Mall · Bay P2-114</div>
</div>
<div className="wsh-pf-prate"><span className="wsh-star">★</span> 4.8</div>
</div>
<div className="wsh-pf-body">
<div>
<div className="wsh-pf-label">Car type</div>
<div className="wsh-pf-pills">
<div className="wsh-pf-pill wsh-on">Sedan</div>
<div className="wsh-pf-pill">SUV</div>
</div>
</div>
<div>
<div className="wsh-pf-label">Service type</div>
<div className="wsh-pf-variant wsh-sel">
<div className="wsh-pf-vtop">
<div className="wsh-pf-radio wsh-on"></div>
<div className="wsh-pf-vlabel">Exterior only</div>
<div className="wsh-pf-vprice">AED 20</div>
</div>
<span className="wsh-pf-vtag wsh-mobile">We come to you</span>
<div className="wsh-pf-bayinput">📍 Enter your level and bay number</div>
</div>
<div className="wsh-pf-variant">
<div className="wsh-pf-vtop">
<div className="wsh-pf-radio"></div>
<div className="wsh-pf-vlabel">Exterior + Interior</div>
<div className="wsh-pf-vprice">AED 35</div>
</div>
<span className="wsh-pf-vtag wsh-park"><span className="wsh-dot"></span> Park at Bay A, Level 2</span>
</div>
</div>
<div>
<div className="wsh-pf-label">Add-ons</div>
<div className="wsh-pf-addon" id="wsh-addonFresh">
<div className="wsh-pf-check"></div>
<div className="wsh-pf-aname">Air freshener</div>
<div className="wsh-pf-aprice">+ AED 5</div>
</div>
<div className="wsh-pf-addon">
<div className="wsh-pf-check"></div>
<div className="wsh-pf-aname">Tyre shine</div>
<div className="wsh-pf-aprice">+ AED 10</div>
</div>
</div>
</div>
<div className="wsh-pf-foot">
<div className="wsh-screen-cta wsh-fs-cta" id="wsh-svcCta">Continue · AED 20</div>
</div>
</div>

<div className="wsh-fs wsh-fs-pay wsh-future" data-screen-label="Step 5 — Payment">
<div className="wsh-pf-statusbar"><span>9:41</span><span>5G  100%</span></div>
<div className="wsh-pay-wrap">
<div className="wsh-pay-sheet">
<div className="wsh-pay-grab"></div>
<div className="wsh-pay-h">How would you like to pay?</div>
<div className="wsh-pay-sub">No charge until your wash is done.</div>
<div className="wsh-pay-opt wsh-sel" id="wsh-payApple">
<div className="wsh-pay-ic wsh-apple"><svg fill="currentColor" viewBox="0 0 24 24"><path d="M16.36 12.78c.02 2.5 2.19 3.33 2.21 3.34-.02.06-.35 1.2-1.15 2.37-.69 1.02-1.41 2.03-2.54 2.05-1.11.02-1.47-.66-2.74-.66-1.27 0-1.66.64-2.71.68-1.09.04-1.92-1.1-2.62-2.12-1.42-2.07-2.51-5.85-1.05-8.4.72-1.27 2.01-2.07 3.41-2.09 1.07-.02 2.08.72 2.74.72.65 0 1.88-.89 3.17-.76.54.02 2.06.22 3.03 1.64-.08.05-1.81 1.06-1.79 3.16M14.3 5.39c.58-.7.97-1.68.86-2.66-.83.03-1.84.55-2.44 1.25-.54.62-1.01 1.61-.88 2.56.93.07 1.88-.47 2.46-1.15"></path></svg></div>
<div className="wsh-pay-meta"><div className="wsh-pay-name">Apple Pay</div><div className="wsh-pay-osub">Fastest checkout</div></div>
<div className="wsh-pay-radio"></div>
</div>
<div className="wsh-pay-opt">
<div className="wsh-pay-ic wsh-card"><svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect height="12" rx="2" width="18" x="3" y="6"></rect><path d="M3 10h18"></path></svg></div>
<div className="wsh-pay-meta"><div className="wsh-pay-name">Add debit / credit card</div><div className="wsh-pay-osub">Visa · Mastercard</div></div>
<div className="wsh-pay-radio"></div>
</div>
<div className="wsh-pay-cta wsh-fs-cta" id="wsh-payCta">
<svg fill="currentColor" viewBox="0 0 24 24"><path d="M16.36 12.78c.02 2.5 2.19 3.33 2.21 3.34-.02.06-.35 1.2-1.15 2.37-.69 1.02-1.41 2.03-2.54 2.05-1.11.02-1.47-.66-2.74-.66-1.27 0-1.66.64-2.71.68-1.09.04-1.92-1.1-2.62-2.12-1.42-2.07-2.51-5.85-1.05-8.4.72-1.27 2.01-2.07 3.41-2.09 1.07-.02 2.08.72 2.74.72.65 0 1.88-.89 3.17-.76.54.02 2.06.22 3.03 1.64-.08.05-1.81 1.06-1.79 3.16M14.3 5.39c.58-.7.97-1.68.86-2.66-.83.03-1.84.55-2.44 1.25-.54.62-1.01 1.61-.88 2.56.93.07 1.88-.47 2.46-1.15"></path></svg>
                  Pay with Apple Pay
                </div>
</div>
</div>
</div>

<div className="wsh-fs wsh-fs-confirmed wsh-future" data-screen-label="Step 6 — Confirmed">
<div className="wsh-pf-statusbar"><span>9:41</span><span>5G  100%</span></div>
<div className="wsh-pf-confirm">
<div className="wsh-chk"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7"></path></svg></div>
<div className="wsh-st">Booking confirmed</div>
<div className="wsh-ss">GeoWash · Dubai Mall · WAS-4F29C1</div>
<div className="wsh-pf-confirm-chip"><span className="wsh-dot"></span> In the queue · Bay P2-114</div>
<div className="wsh-pf-confirm-note">Sit back — we'll notify you the moment your car is ready.</div>
</div>
</div>

<div className="wsh-fs wsh-fs-lock wsh-future" data-screen-label="Step 7 — Notification">
<div className="wsh-pf-statusbar" style={{ color: "rgba(255,255,255,.92)" }}><span>10:14</span><span>5G  100%</span></div>
<div className="wsh-pf-lock">
<div className="wsh-pf-lock-clock">10:14</div>
<div className="wsh-pf-lock-date">Thursday, June 18</div>
<div className="wsh-pf-notif" id="wsh-pfNotif">
<div className="wsh-pf-notif-icon"><img alt="Washta" src={washtaLogoMark}/></div>
<div className="wsh-pf-notif-body">
<div className="wsh-pf-notif-top"><span>Washta</span><span>now</span></div>
<div className="wsh-pf-notif-title">Your car is ready ✨</div>
<div className="wsh-pf-notif-text">The carwash expert team just finished your exterior wash at Bay P2-114. Tap to rate your wash.</div>
</div>
</div>
</div>
</div>

<div className="wsh-launch" id="wsh-appLaunch">
<img alt="Washta" className="wsh-launch-mark" src={washtaLogoMark}/>
<div className="wsh-launch-name">Washta</div>
</div>
</div>
</div>
</div>
</div>
</section>
  );
}
